import { normalizeRangeDate } from "./dateRangeUtils";

export const buildLeaveApproval = (row, approver, status = "Approved", reason) => ({
  id: row.id,
  approver_id: approver.id,
  request_status: status,
  approver_name: approver.first_name,
  ...(status === "Rejected" && { reason }),
});

export const buildBreakApproval = (row, status = "Approved", reason) => {
  const common = {
    id: row.id,
    user_id: row.user_id,
    reason: row.reason,
    status,
    ...(status === "Rejected" && { rejected_reason: reason }),
  };
  if (row.attendance_type === "Cancel Break") {
    const breakIds = row.break_ids?.length
      ? row.break_ids
      : row.breaks_to_cancel?.length
        ? row.breaks_to_cancel.map((entry) => entry.break_id).filter(Boolean)
        : row.breaks?.length
          ? row.breaks.map((entry) => entry.break_id ?? entry.id).filter(Boolean)
          : row.break_id ? [row.break_id] : [];

    return {
      ...common,
      attendance_type: "Cancel Break",
      break_ids: breakIds,
    };
  }
  return {
    ...common,
    attendance_type: "break",
    break_type: row.raw_break_type || row.break_type,
    break_start_time: row.raw_break_start_time || row.break_start_time,
    break_end_time: row.raw_break_end_time || row.break_end_time,
    duration: row.duration,
    date: normalizeRangeDate(row.date) || null,
  };
};

// Use the existing single-request endpoints; retain failed items for retry.
export const approveRequests = async (rows, approveRow) => {
  const approvedIds = new Set();
  for (const row of rows) {
    try {
      const response = await approveRow(row);
      if (response?.ok) approvedIds.add(row.id);
      // Stop when the API helper has triggered session handling.
      if (!response || [401, 409].includes(response.code)) break;
    } catch {
      // A failed request must not hide successful approvals in the batch.
    }
  }
  return { approvedIds, failedCount: rows.length - approvedIds.size };
};
